import { render, staticRenderFns } from "./image-srcset.vue?vue&type=template&id=2b35ead7&scoped=true&"
import script from "./image-srcset.vue?vue&type=script&lang=js&"
export * from "./image-srcset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b35ead7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/bartlomiejewiak/56degrees/Projekty/gv-health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b35ead7')) {
      api.createRecord('2b35ead7', component.options)
    } else {
      api.reload('2b35ead7', component.options)
    }
    module.hot.accept("./image-srcset.vue?vue&type=template&id=2b35ead7&scoped=true&", function () {
      api.rerender('2b35ead7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/partials/image-srcset.vue"
export default component.exports